import { Col, Row } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import ProductContext from "../../../context/product/context";
import { getProductStatus, getProductType } from "../../../models/product/enum";
import { ICategory } from "../../../models/category/response";
import AppContext from "../../../context/app/context";
import EndPoints from "../../../services/end-points";
import { ITrademark } from "../../../models/trademark/response";
import { IStore } from "../../../models/store/response";
import CategoryContext from "../../../context/category/context";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { useLocation } from "react-router-dom";


interface IProps { }

const ProductFilter: React.FC<IProps> = () => {

  const { t } = useTranslation();
  const { actions, query } = useContext(ProductContext);

  const { allCategories, actions: { getAllData } } = useContext(CategoryContext);
  const [mainCat, setMainCat] = useState<number>();
  const [parentCat, setParentCat] = useState<number>();
  const [subCategories, setSubCategories] = useState<ICategory[]>([]);
  const [subCategoryLoadign, setSubCategoriesLoading] = useState<boolean>(false);

  const [trademarks, setTrademarks] = useState<ITrademark[]>([]);
  const [trademarkLoading, setTrademarkLoading] = useState(false);

  const [stores, setStores] = useState<IStore[]>([]);
  const [storesLoading, setStoresLoading] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState<number | undefined>();

  const { direction } = useContext(AppContext);
  const userPermissions = localStorage?.getItem("permisionStoroge")?.split(",");
  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]);

  useEffect(() => {
    if (!userPermissions.includes("can_view_pads")) {

      const getSubCategories = async () => {
        try {
          const { data } = await EndPoints.category.getAllCategories({
            light: true,
            perPage: -1,
            filters: [
              {
                name: "parentId",
                operation: "neq",
                value: null,
              },
            ],
          });
          setSubCategories(data.data);
          setSubCategoriesLoading(false);
        } catch (error) {
        } finally {
          setSubCategoriesLoading(false);
        }
      };
      getSubCategories();
    }
    !allCategories && getAllData();
  }, [direction]);

  useEffect(() => {
    const getTrademrks = async () => {
      try {
        const { data } = await EndPoints.trademark.getAllTrademark({
          light: true,
          perPage: -1,
        });
        setTrademarks(data.data);
        setTrademarkLoading(false);
      } catch (error) {
      } finally {
        setTrademarkLoading(false);
      }
    };
    getTrademrks();
  }, [direction]);

  // Fetch namla stores for filter
  useEffect(() => {
    const getStores = async () => {
      setStoresLoading(true);
      try {
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
          isNamlieah: true,
        });
        setStores(data.data);
      } catch (error) {
      } finally {
        setStoresLoading(false);
      }
    };
    getStores();
  }, [direction]);
  return (
    <Form
      formId="product-filter"
      defaultValues={initialValues}

      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
            data?.isNew
              ? {
                name: "isNew",
                value: data.isNew,
                operation: "eq",
              }
              : undefined,
            data?.trademarkId
              ? {
                name: "trademarkId",
                value: data.trademarkId,
                operation: "eq",
              }
              : undefined,
            data?.needRecipe
              ? {
                name: "needRecipe",
                value: data?.needRecipe,
                operation: "eq",
              }
              : undefined,
            data?.mainCategoryId
              ? {
                name: "mainCategoryId",
                value: data?.mainCategoryId,
                operation: "eq",
              }
              : undefined,
            data?.parentCategoryId
              ? {
                name: "parentCategoryId",
                value: data?.parentCategoryId,
                operation: "eq",
              }
              : undefined,
            data?.childCategoryId
              ? {
                name: "childCategoryId",
                value: data?.childCategoryId,
                operation: "eq",
              }
              : undefined,
            data?.status
              ? {
                name: "status",
                value: data?.status,
                operation: "eq",
              }
              : undefined,
            data?.available
              ? {
                name: "available",
                value: data?.available,
                operation: "eq",
              }
              : undefined,
            data?.storeId
              ? {
                name: "storeId",
                value: data?.storeId,
                operation: "eq",
              }
              : undefined,
            data?.storeId && data?.storeStatus
              ? {
                name: "storeStatus",
                value: data?.storeStatus,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };

        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              options: [1, 2].map((type, index) => {
                return {
                  label: t(getProductType(type) as string),
                  value: type as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="isNew"
            label={`${t("new")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              loading: subCategoryLoadign,
              options: [1, 2].map((cat, index) => {
                return {
                  label: index == 0 ? t("yes") : t("no"),
                  value: index == 0 ? 1 : "0",
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="trademarkId"
            label={`${t("trademark")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              loading: trademarkLoading,
              allowSearch: true,

              options: trademarks.map((trademark, index) => {
                return {
                  key: index,
                  label: trademark?.name,
                  value: trademark?.id as number,
                };
              }),
            }}
          />
        </Col>
      
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="mainCategoryId"
            label={`${t("main_category")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: allCategories
                ?.filter((cat) => cat?.parent === null && cat?.grand === null)
                .map((grand, index) => {
                  return {
                    type: "select",
                    label: grand?.name as string,
                    value: grand?.id as number,
                  };
                }),
              onChange: (val) => {
                setMainCat(val);
              },
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="parentCategoryId"
            label={`${t("parent_category")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: allCategories
                ?.filter((cat) =>
                  mainCat
                    ? cat?.parent === null && cat?.grand?.id == mainCat
                    : cat?.parent === null && cat?.grand?.id !== null
                )
                .map((grand, index) => {
                  return {
                    type: "select",
                    label: grand?.name as string,
                    value: grand?.id as number,
                  };
                }),
              onChange: (val) => {
                setParentCat(val);
              },
            }}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="childCategoryId"
            label={`${t("child_category")}`}
            width="large"
            input={{
              type: "multiSelect",
              allowSearch: true,
              options: allCategories
                ?.filter((cat) =>
                  mainCat && parentCat
                    ? cat?.parent?.id === parentCat && cat?.grand?.id == mainCat
                    : cat?.parent !== null && cat?.grand?.id !== null
                )
                .map((grand, index) => {
                  return {
                    type: "select",
                    label: grand?.name as string,
                    value: grand?.id as number,
                  };
                }),
            }}
          />
        </Col>
      
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="needRecipe"
            label={`${t("need_recipe")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              options: [1, 2].map((status, index) => {
                return {
                  key: index,
                  label: status === 1 ? t("yes") : t("no"),
                  value: status === 1 ? 1 : "0",
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="available"
            label={`${t("available")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              options: [1, 2].map((cat, index) => {
                return {
                  label: index == 0 ? t("yes") : t("no"),
                  value: index == 0 ? 1 : "0",
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              options: [1, 2].map((statu, index) => {
                return {
                  label: t(getProductStatus(statu) as string),
                  value: statu as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="storeId"
            label={`${t("store")}`}
            width="large"
            rules={{ required: false }}
            input={{
              type: "select",
              loading: storesLoading,
              allowSearch: true,
              options: stores.map((store) => {
                return {
                  label: store?.name,
                  value: store?.id as number,
                };
              }),
              onChange: (val) => {
                setSelectedStoreId(val);
              },
            }}
          />
        </Col>
        {selectedStoreId && (
          <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
            <FieldBuilder
              name="storeStatus"
              label={`${t("store_status")}`}
              width="large"
              rules={{ required: false }}
              input={{
                type: "select",
                options: [1, 2].map((statu) => {
                  return {
                    label: t(getProductStatus(statu) as string),
                    value: statu as number,
                  };
                }),
              }}
            />
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default ProductFilter;
